import React, { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";
import { decryptText } from "../../utils/cipherText";
import InvokePage from "./Invoke/InvokePage";
import { tr } from "date-fns/locale";
import RevokePage from "./Revoke/RevokePage";
import { sideBarContext } from "../../App";

export const LoanActionContext = createContext();
function LoanActionRevoke() {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [users, setUsers] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const token = localStorage.getItem("token");
  const [pledgedAvailable, setPledgedAvailable] = useState(true);

  const [current, setCurrent] = useState("revoke");
  const { expanded } = useContext(sideBarContext);

  return (
    <LoanActionContext.Provider value={current}>
      <div
        className={`${
          expanded ? "w-[calc(100%-240px)]" : "w-[calc(100%-90px)]"
        } bg-[#f1f1f6] min-h-[100vh]`}
      >
        {/* <div className="mx-[20px] mt-4  border-b-[3px] border-[#92e86c] rounded-t-lg  bg-white my-2 ">
          <button
            className={` py-3 px-12  rounded-t-lg ${
              current === "invoke" ? "bg-[#92e86c] font-semibold" : ""
            }`}
            onClick={() => setCurrent("invoke")}
          >
            Invoke
          </button>{" "}
          <button
            className={`py-3 px-12 rounded-t-lg ${
              current === "revoke" ? "bg-[#92e86c] font-semibold" : ""
            }`}
            onClick={() => setCurrent("revoke")}
          >
            Revoke
          </button>
        </div> */}

        {current === "invoke" && <InvokePage />}
        {current === "revoke" && <RevokePage />}
      </div>
    </LoanActionContext.Provider>
  );
}

export default LoanActionRevoke;
